/**
 * The next default segment name on a phone (spec 11.5): "Part N", one past
 * both the highest "Part" number in use and the count, so deleting a segment
 * never makes a new one repeat a name.
 */
export function nextPartName(labels: string[]): string {
  let max = labels.length;
  for (const l of labels) {
    const m = /^Part (\d+)$/.exec(l.trim());
    if (m) max = Math.max(max, Number(m[1]));
  }
  return `Part ${max + 1}`;
}
